import React from "react";
import constData from "../../../utilities/const.json";
import { ReactComponent as PazirexLogo } from "./../../../assets/images/Logo/Logo-name-Pazirex-Blue.svg";
import { ReactComponent as CopyRightIcon } from "./../../../assets/images/icons/Google SVGs/copyright.svg";
import { ReactComponent as ArrowInsertIcon } from "./../../../assets/images/icons/Google SVGs/arrow_insert.svg";

const Footer = () => {
  const isMobile = window.innerWidth >= 992 ? false : true;

  return (
    // 208px is sidebar width
    <div className="p-2">
      <div
        className="mx-0"
        // style={{ minHeight: "10vh" }}
      >
        <footer
          className="d-flex flex-wrap justify-content-between align-items-center"
          style={{
            paddingBottom: isMobile ? constData.elementSize.MobileAppbar : null,
          }}
        >
          <div className="d-flex row w-100 m-0 background-bootstrap-gray-100 color-bootstrap-gray-700 pb-0 py-12px gx=12 fs-14 rounded-top-2 border border-bootstrap-gray-300 border-buttom-0">
            <div className="d-flex col flex-column justify-content-lg-start justify-content-center">
              <PazirexLogo width={85.5} type="button" />
              <span className="mt-2">
                با عضویت در سامانه پذیرکس، پیشرفته‌ترین مدیریت نوبت‌دهی مطب و
                کلینیک را تجربه کنید.
              </span>
            </div>
            <div className="d-flex col-auto">
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=511634&Code=Dw5kDuSYuXtgnPwImuFOn1uYyrXOxnaE"
              >
                <img
                  className="rounded-2"
                  referrerPolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=511634&Code=Dw5kDuSYuXtgnPwImuFOn1uYyrXOxnaE"
                  alt=""
                  height={68}
                  code="Dw5kDuSYuXtgnPwImuFOn1uYyrXOxnaE"
                />
              </a>
            </div>
            <hr className="my-12px" />
            <div className="d-flex col-12 row gx-12 gy-2 mt-0 justify-content-start align-items-center">
              {/* <span className="col-auto d-flex flex-row mt-0 mb-2 h-25px" type="button">
                صفحه اصلی
                <ArrowInsertIcon className="ms-1" width={20} />
              </span> */}

              {/* <span className="col-auto d-flex flex-row mt-0 mb-2 h-25px" type="button">
                درباره ما
                <ArrowInsertIcon className="ms-1" width={20} />
              </span> */}

              <div
                className="col-lg-auto col-7 d-flex flex-row mt-0 mb-2 h-25px"
                type="button"
              >
                <a
                  href={constData.offSiteURL["registration-medical-centers"]}
                  target="_blank"
                  className="color-bootstrap-gray-700 text-decoration-none"
                >
                  ثبت نام رایگان مرکز درمانی
                  <ArrowInsertIcon className="ms-1" width={20} />
                </a>
              </div>

              <div
                className="col-lg-auto col-5 d-flex flex-row mt-0 mb-2 h-25px"
                // type="button"
              >
                <span
                  // href={constData.offSiteURL["site-guide"]}
                  // target="_blank"
                  className="color-bootstrap-gray-600 text-decoration-none"
                >
                  راهنمای سایت
                  <ArrowInsertIcon className="ms-1" width={20} />
                </span>
              </div>

              <div
                className="col-lg-auto col-7 d-flex flex-row mt-0 mb-2 h-25px"
                type="button"
              >
                <a
                  href={constData.offSiteURL["registration-doctors"]}
                  target="_blank"
                  className="color-bootstrap-gray-700 text-decoration-none"
                >
                  ثبت نام رایگان پزشک
                  <ArrowInsertIcon className="ms-1" width={20} />
                </a>
              </div>
              <div
                className="col-lg-auto col-5 d-flex flex-row mt-0 mb-2 h-25px"
                type="button"
              >
                <a
                  href={constData.offSiteURL["faq"]}
                  target="_blank"
                  className="color-bootstrap-gray-700 text-decoration-none"
                  name="faq"
                >
                  سوالات متداول
                  <ArrowInsertIcon className="ms-1" width={20} />
                </a>
              </div>
            </div>
          </div>
          <div className="d-flex row w-100 ms-0 color-bootstrap-gray-100 background-bootstrap-gray-700 py-2 fs-10 rounded-bottom">
            <div className="col d-flex justify-content-center align-items-center">
              <CopyRightIcon
                className="me-2"
                width={isMobile ? 20 : 24}
                height={isMobile ? 20 : 24}
              />
              تمامی حقوق مادی و معنوی این وب سایت به پذیرکس تعلق دارد.
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
